import React from 'react'
import { auth } from '../../database/firebase'
import LogoutIcon from '@mui/icons-material/Logout';


const SignOutButton = () => {
  const signOut = () => {
    auth.signOut()
    window.location.href = '/';
  }
  return (
    <div style={{ width: "200px", position: "absolute", bottom: "50px", left: "50px " }} >
      <button onClick={() => { signOut() }} style={{ cursor: 'pointer', fontSize: '20px', borderBottom: '1.5px solid #d2cece', borderTop: '1.5px solid #d2cece', width: '155px', height: '60px', margin: '0 auto', display: 'flex', alignItems: 'center', whiteSpace: "nowrap" }}>
        <LogoutIcon sx={{ width: '30px', height: '30px', justifyContent: 'center' }}>
        </LogoutIcon>
        &nbsp;&nbsp;Sign out
      </button>
    </div >
  )
}

export default SignOutButton
